import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import { forgotValidation } from "../../../utils/Validation";
import { useNavigate } from "react-router-dom";
import { supplierSendCode } from "../../../services/supplier/authenticationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import AppLoader from "../../../components/AppLoader";

const ForgotForm = () => {
  const navigate = useNavigate();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState({
    email: "",
  });
  const [inputError, setInputError] = useState({
    email: false,
    isEmailValid: false,
  });

  // Function

  const handleSendCode = async () => {
    try {
      const validate = forgotValidation(inputValues, setInputError);
      if (validate) {
        return;
      }
      let payload = {
        email: inputValues.email,
        purpose: "Forget Password",
        role: "Supplier",
      };
      setIsLoading(true);
      const response = await supplierSendCode(payload);
      if (response.data.status === "success") {
        navigate("/forgot-password/verify");
        handleOpenSnackBar("success", response.data.message);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
      // localStorage.setItem("user-data", JSON.stringify(payload));
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeValues = (event) => {
    const { name, value } = event.target;
    setInputError((prevError) => ({
      ...prevError,
      [name]: false,
      isEmailValid: name === "email" ? false : inputError.isEmailValid,
    }));
    setInputValues((pre) => ({ ...pre, [name]: value }));
  };
  return (
    <Box component={"form"} sx={{ mt: 5 }}>
      <AppLoader isVisible={isLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Label labelText="User Id" htmlFor={"user-id"} required />
          <TextInput
            inputError={inputError.email || inputError.isEmailValid}
            helperText={
              inputError.email
                ? "Email is required"
                : inputError.isEmailValid
                ? "Invalid email format"
                : null
            }
            id={"user-id"}
            required={true}
            placeholder={"Enter Email Address"}
            type={"email"}
            name="email"
            value={inputValues.email}
            onChange={handleChangeValues}
          />
        </Grid>
      </Grid>

      <Box mt={5}>
        <GlobalButton
          variant={"contained"}
          btnText={"Next"}
          handleClickBtn={handleSendCode}
        />
      </Box>
    </Box>
  );
};

export default ForgotForm;
